import styled from 'styled-components';
import shadowDay from '../../assets/images/shadow_filter_day.png';

const Shadow = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 2320px;
	height: 1480px;

	background-image: url(${shadowDay});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	opacity: 1;
	transition: opacity 0.3s ease;

	&.shadow-enter {
		opacity: 1;
	}

	&.shadow-enter-active,
	&.shadow-enter-done,
	&.shadow-exit {
		opacity: 0;
	}

	&.shadow-exit-active {
		opacity: 1;
	}
`;

export { Shadow };
